const state = {
  image: null,
  images: [],
};

const getters = {
  image: (state) => state.image,
  images: (state) => state.images,
};

const actions = {
  setImage({ commit }, image) {
    commit("setImage", image);
  },
  setImages({ commit }, images) {
    commit("setImages", images);
  },
};

const mutations = {
  setImage(state, image) {
    state.image = image;
  },
  setImages(state, images) {
    state.images = images;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
